import React from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import moment from "moment";
import NewColors from "../../../../../themes/NewColors";
import useWaterUnit from "../../../../../hooks/useWaterUnit";

function rowCalories(rd) {
  if (typeof rd.kCal === "number" && rd.kCal > 0) return rd.kCal;
  const p = rd.proteins || 0;
  const c = rd.carbs || 0;
  const f = rd.fats || 0;
  return Math.round(p * 4 + c * 4 + f * 9);
}

/**
 * Last N days of reportHealth-derived rows (same shape as useClientNutritionChartData).
 */
const NutritionRecentTable = ({ nutritionChartData, maxRows = 14 }) => {
  const { waterLabel, unit: waterUnit } = useWaterUnit();
  const rows = React.useMemo(() => {
    if (!nutritionChartData || !nutritionChartData.length) return [];
    const sorted = [...nutritionChartData].sort(
      (a, b) => new Date(b.createdOn) - new Date(a.createdOn),
    );
    return sorted.slice(0, maxRows);
  }, [nutritionChartData, maxRows]);

  if (!rows.length) {
    return (
      <Typography variant="body2" color="text.secondary" sx={{ py: 2 }}>
        No daily nutrition rows in this window.
      </Typography>
    );
  }

  return (
    <TableContainer component={Paper} variant="outlined" sx={{ borderRadius: 2 }}>
      <Table size="small">
        <TableHead>
          <TableRow sx={{ backgroundColor: NewColors.sectionBackground }}>
            <TableCell>Date</TableCell>
            <TableCell align="right">Water ({waterUnit})</TableCell>
            <TableCell align="right">Fiber</TableCell>
            <TableCell align="right">kcal</TableCell>
            <TableCell align="right">P / C / F</TableCell>
            <TableCell align="right">Sleep</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, i) => {
            const micro = row.micronutrients || {};
            const fiber = typeof micro.fiber === "number" ? micro.fiber : 0;
            return (
              <TableRow key={i}>
                <TableCell>
                  {row.createdOn
                    ? moment(row.createdOn).format("MMM D")
                    : "—"}
                </TableCell>
                <TableCell align="right">{waterLabel(row.water || 0)}</TableCell>
                <TableCell align="right">
                  {fiber > 0 ? `${Math.round(fiber * 10) / 10} g` : "—"}
                </TableCell>
                <TableCell align="right">{rowCalories(row)}</TableCell>
                <TableCell align="right" sx={{ whiteSpace: "nowrap" }}>
                  {Math.round(row.proteins || 0)} / {Math.round(row.carbs || 0)} /{" "}
                  {Math.round(row.fats || 0)} g
                </TableCell>
                <TableCell align="right">
                  {row.sleepHours > 0 ? `${row.sleepHours} h` : "—"}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default NutritionRecentTable;
